import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Button, Paper, Stack } from "@mui/material";
import FromAndToDatePicker from "../../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import TotalCountDisplay from "./TotalCountDisplay";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import InduvidualAssessmentReport from "../../assessmentReportInduvidual/InduvidualAssessmentReport";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import { Icon } from "@iconify/react";
import useResponsive from "../../../Hooks/useResponsive";
import { useSelector } from "react-redux";
import { getCROViewLeadDetails } from "../../../redux/features/CRDslice";
import { useDispatch } from "react-redux";
import { croTableViewHeader } from "../../../components/datagrid/myworkspace/crd/croTableViewHeader";

const CROView = () => {
  const navigate = useNavigate("");
  const location = useLocation();
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;
  const searchParams = new URLSearchParams(location.search);
  const croIdParams = searchParams.get("id");
  const [croId, setCroId] = useState(
    croIdParams ? croIdParams : userProfile.userId
  );
  const fromDateParam = searchParams.get("fromDate");
  const toDateParam = searchParams.get("toDate");
  const [fromDate, setFromDate] = useState(
    fromDateParam || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    toDateParam || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [direction, setDirection] = useState("row");
  const smDown = useResponsive("down", "sm");
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { loading, leadDetails } = useSelector((store) => store.crd);

  // useEffect(() => {
  //   setCroId(croIdParams || userProfile.userId);
  // }, [croIdParams, userProfile.userId]);

  const dispatchParams = {
    fromDate,
    toDate,
    croId,
    paginationData,
  };
  useEffect(() => {
    if (smDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [smDown]);
  useEffect(() => {
    if (paginationData?.pageNum) {
      dispatch(getCROViewLeadDetails(dispatchParams));
    }
  }, [fromDate, toDate, croId, gridSize, pageNum, search]);
  return (
    <GlobalWrapper title={"CRO Assessment Report"}>
      <Stack gap={1} direction={direction}>
        <Box>
          <FromAndToDatePicker
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </Box>
      </Stack>
      {/* <Box mt={1}>
        <TotalCountDisplay
          totalStudents={100}
          totalCourses={500}
          assignedStudents={60}
          unAssignedStudents={40}
        />
      </Box> */}
      <Box mt={1}>
        <Paper elevation={1}>
          <GlobalDatagrid
            tableHead={croTableViewHeader}
            rows={leadDetails?.data}
            meta={leadDetails?.meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={true}
            actionComponent={
              <>
                <ActionDetails val={rowData?.name} />

                {rowData?.isAssessmentTaken == "YES" && (
                  <GlobalAnchorList
                    component={
                      <InduvidualAssessmentReport
                        sx={{
                          p: "7px",
                          background:
                            "linear-gradient(135deg, #2f72b3, #1e65ab6e)",
                          color: "#fff",
                          "&:hover": {
                            background:
                              "linear-gradient(135deg,rgb(7, 71, 136),rgba(4, 19, 34, 0.43))",
                          },
                        }}
                        leadId={rowData?.leadId}
                        buttonName={"View Assessment Report"}
                        btnIcon={<Icon icon="mdi:eye" width="20" height="20" />}
                      />
                    }
                  />
                )}

                <GlobalAnchorList
                  component={
                    <Box>
                      <Button
                        sx={{
                          p: "7px",
                          px: "10px",
                          background:
                            "linear-gradient(135deg, #2f72b3, #1e65ab6e)",
                          color: "#fff",
                          "&:hover": {
                            background:
                              "linear-gradient(135deg,rgb(7, 71, 136),rgba(4, 19, 34, 0.43))",
                          },
                        }}
                        onClick={() =>
                          navigate(`/assessment-tool/student-registration`)
                        }
                        variant="outlined"
                      >
                        <Icon
                          icon="mingcute:user-search-fill"
                          width="20"
                          height="20"
                        />
                        Go To Take Assessment
                      </Button>
                    </Box>
                  }
                />

                <GlobalAnchorList
                  component={
                    <Box>
                      <Button
                        sx={{
                          p: "7px",
                          px: "10px",
                          background:
                            "linear-gradient(135deg, #2f72b3, #1e65ab6e)",
                          color: "#fff",
                          "&:hover": {
                            background:
                              "linear-gradient(135deg,rgb(7, 71, 136),rgba(4, 19, 34, 0.43))",
                          },
                        }}
                        onClick={() =>
                          navigate(`/my-workspace/academic-calendar?leadId=${rowData?.leadId}`)
                        }
                        variant="outlined"
                      >
                        <Icon icon="mdi:eye" width="20" height="20" />
                        Academic Calendar
                      </Button>
                    </Box>
                  }
                />
              </>
            }
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default CROView;
